module.exports = __webpack_public_path__ + "images/icon_close_white2d68f0b1e42dea0593914a64dd70902b.svg";